import React, { Suspense } from "react";
import { useTranslation } from "react-i18next";
import { FORMATION_CONFIG } from "../../../../helpers/formationConfig";
import SpinnerComponent from "../../../SpinnerComponent/SpinnerComponent";
import "./index.less";

interface FormationModalProps {
  visible: boolean;
  handleTutorialRead: () => void;
  id: keyof typeof FORMATION_CONFIG;
}

const FormationModalComponent: React.FC<FormationModalProps> = ({ visible, handleTutorialRead, id }) => {
  const { t } = useTranslation();

  const config = FORMATION_CONFIG[id];
  if (!visible) return null;

  const { component: Component } = config;

  const handleModalClick = (e: React.MouseEvent<HTMLDivElement, MouseEvent>) => {
    e.stopPropagation();
  };

  return (
    <div className="formation-modal-overlay no-scroll" onClick={handleTutorialRead}>
      <div className="formation-modal-content no-scroll-horizontal" onClick={handleModalClick}>
        <Suspense
          fallback={
            <div className="w-full d-flex justify-content-center">
              <SpinnerComponent />
            </div>
          }
        >
          <Component fromModal={true} />
          <div className="sticky-button-container">
            <button className="sticky-button" onClick={handleTutorialRead}>
              {t("i-understand")}
            </button>
          </div>
        </Suspense>
      </div>
    </div>
  );
};

export default FormationModalComponent;
